import { SavedAPIAddress } from '~/types/APIAddress';
import ParcelTemplate from '~/types/ParcelTemplate';
import { RateAtCheckoutErrorArray, ShippingOptionPayload } from '~/types/RatesAtCheckout';
import { ActionKeys } from './constants';

export function fetchShippingOptions() {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_FETCH_SHIPPING_OPTIONS,
  };
}

export function fetchShippingOptionsSuccess(payload: { data: ShippingOptionPayload[] }) {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_FETCH_SHIPPING_OPTIONS_SUCCESS,
    payload,
  };
}

export function fetchShippingOptionsError(errorMessage: string) {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_FETCH_SHIPPING_OPTIONS_ERROR,
    payload: { errorMessage },
  };
}

export function updateShippingOption(payload: unknown) {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_UPDATE_SHIPPING_OPTION,
    payload,
  };
}

export function updateShippingOptionSuccess(payload: { data: ShippingOptionPayload }) {
  return <const>{
    payload,
    type: ActionKeys.RATES_AT_CHECKOUT_UPDATE_SHIPPING_OPTION_SUCCESS,
  };
}

export function updateShippingOptionError(errors: RateAtCheckoutErrorArray) {
  return <const>{
    payload: { errors },
    type: ActionKeys.RATES_AT_CHECKOUT_UPDATE_SHIPPING_OPTION_ERROR,
  };
}

export function deleteShippingOption(payload: string) {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_DELETE_SHIPPING_OPTION,
    payload,
  };
}

export function deleteShippingOptionSuccess(payload: { data: string }) {
  return <const>{
    payload,
    type: ActionKeys.RATES_AT_CHECKOUT_DELETE_SHIPPING_OPTION_SUCCESS,
  };
}

export function deleteShippingOptionError(errorMessage: string) {
  return <const>{
    payload: { errorMessage },
    type: ActionKeys.RATES_AT_CHECKOUT_DELETE_SHIPPING_OPTION_ERROR,
  };
}

export function createShippingOption(payload: unknown) {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_CREATE_SHIPPING_OPTION,
    payload,
  };
}

export function createShippingOptionSuccess(payload: { data: ShippingOptionPayload }) {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_CREATE_SHIPPING_OPTION_SUCCESS,
    payload,
  };
}

export function createShippingOptionError(errors: RateAtCheckoutErrorArray) {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_CREATE_SHIPPING_OPTION_ERROR,
    payload: { errors },
  };
}

export function openAddShippingOptionModal() {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_OPEN_ADD_RULE_MODAL,
  };
}

export function closeAddShippingOptionModal() {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_CLOSE_ADD_RULE_MODAL,
  };
}

export function fetchLiveRatePackage() {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_FETCH_LIVE_RATE_PACKAGE,
  };
}

export function fetchLiveRatePackageSuccess(payload: { data: { result: ParcelTemplate } }) {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_FETCH_LIVE_RATE_PACKAGE_SUCCESS,
    payload,
  };
}

export function fetchLiveRatePackageError(errorMessage: string) {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_FETCH_LIVE_RATE_PACKAGE_ERROR,
    payload: { errorMessage },
  };
}

export function updateLiveRatePackage(payload: string) {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_PACKAGE,
    payload,
  };
}

export function updateLiveRatePackageSuccess(payload: { data: ParcelTemplate }) {
  return <const>{
    payload,
    type: ActionKeys.RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_PACKAGE_SUCCESS,
  };
}

export function updateLiveRatePackageError(errorMessage: string) {
  return <const>{
    payload: { errorMessage },
    type: ActionKeys.RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_PACKAGE_ERROR,
  };
}

export function fetchLiveRateSenderAddress() {
  return <const>{
    type: ActionKeys.RATES_AT_CHECKOUT_FETCH_LIVE_RATE_SENDER_ADDRESS,
  };
}

export function fetchLiveRateSenderAddressSuccess(senderAddress: SavedAPIAddress) {
  return <const>{
    payload: { senderAddress },
    type: ActionKeys.RATES_AT_CHECKOUT_FETCH_LIVE_RATE_SENDER_ADDRESS_SUCCESS,
  };
}

export function fetchLiveRateSenderAddressError(errorMessage: string) {
  return <const>{
    payload: { errorMessage },
    type: ActionKeys.RATES_AT_CHECKOUT_FETCH_LIVE_RATE_SENDER_ADDRESS_ERROR,
  };
}

export function updateLiveRateSenderAddress(liveRatesAddressId: number) {
  return <const>{
    payload: { liveRatesAddressId },
    type: ActionKeys.RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_SENDER_ADDRESS,
  };
}

export function updateLiveRateSenderAddressSuccess(senderAddress: SavedAPIAddress) {
  return <const>{
    payload: { senderAddress },
    type: ActionKeys.RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_SENDER_ADDRESS_SUCCESS,
  };
}

export function updateLiveRateSenderAddressError(errorMessage: string) {
  return <const>{
    payload: { errorMessage },
    type: ActionKeys.RATES_AT_CHECKOUT_UPDATE_LIVE_RATE_SENDER_ADDRESS_ERROR,
  };
}

export type RatesAtCheckoutActions =
  | ReturnType<typeof fetchShippingOptions>
  | ReturnType<typeof fetchShippingOptionsSuccess>
  | ReturnType<typeof fetchShippingOptionsError>
  | ReturnType<typeof updateShippingOption>
  | ReturnType<typeof updateShippingOptionSuccess>
  | ReturnType<typeof updateShippingOptionError>
  | ReturnType<typeof createShippingOption>
  | ReturnType<typeof createShippingOptionSuccess>
  | ReturnType<typeof createShippingOptionError>
  | ReturnType<typeof deleteShippingOption>
  | ReturnType<typeof deleteShippingOptionSuccess>
  | ReturnType<typeof deleteShippingOptionError>
  | ReturnType<typeof openAddShippingOptionModal>
  | ReturnType<typeof closeAddShippingOptionModal>
  | ReturnType<typeof fetchLiveRatePackage>
  | ReturnType<typeof fetchLiveRatePackageSuccess>
  | ReturnType<typeof fetchLiveRatePackageError>
  | ReturnType<typeof updateLiveRatePackage>
  | ReturnType<typeof updateLiveRatePackageSuccess>
  | ReturnType<typeof updateLiveRatePackageError>
  | ReturnType<typeof fetchLiveRateSenderAddress>
  | ReturnType<typeof fetchLiveRateSenderAddressSuccess>
  | ReturnType<typeof fetchLiveRateSenderAddressError>
  | ReturnType<typeof updateLiveRateSenderAddress>
  | ReturnType<typeof updateLiveRateSenderAddressSuccess>
  | ReturnType<typeof updateLiveRateSenderAddressError>;
